import { render } from "./OpennessOrganizationCategoryForm.vue?vue&type=template&id=2d0cd669&scoped=true"
import script from "./OpennessOrganizationCategoryForm.vue?vue&type=script&lang=js"
export * from "./OpennessOrganizationCategoryForm.vue?vue&type=script&lang=js"

import "./OpennessOrganizationCategoryForm.vue?vue&type=style&index=0&id=2d0cd669&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0cd669"]])

export default __exports__